// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"4334":"cf99f9a1d1687786","5364":"0cce2f53c0b492be","7741":"c6f4934aefa10c74"}[chunkId] + ".js";
};